module.exports = __webpack_public_path__ + "img/slides_16.23fe94e6.jpg";